// Canonical domain, matching the existing robots.txt / llms.txt / ai.txt
// convention (apex, no www).
export const SITE_URL = 'https://al-amentech.io';

// The live flagship product — every "try it" CTA across the site should
// point here, not at the in-repo illustrative /playground demo.
export const URBANAI_URL = 'https://urbanai.al-amentech.io';
export const URBANAI_DEMO_VIDEO_URL = 'https://urbanai.al-amentech.io/video';
